import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PrinterService, ReplacementThresholdService } from '../../../api/services';
import { thresholdActions } from './threshold.action';
import { inject } from '@angular/core';
import { mapResponse } from '@ngrx/operators';
import { delay, exhaustMap, switchMap } from 'rxjs';
import { LoadingState } from '../models/loader.model';
import { getErrorMessage, ZetraError } from '../../shared/errors/error-messages.helper';

export const loadAllThresholdsEffect = createEffect(
  (actions$ = inject(Actions), printerService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(thresholdActions.loadAll),
      switchMap((props) =>
        printerService.printerControllerGetThresholds({ ...props }).pipe(
          mapResponse({
            next: (r) => thresholdActions.loadAllDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: ZetraError) =>
              thresholdActions.loadAllDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);

export const loadThresholdEffect = createEffect(
  (actions$ = inject(Actions), thresholdService = inject(ReplacementThresholdService)) => {
    return actions$.pipe(
      ofType(thresholdActions.loadThreshold),
      exhaustMap((props) =>
        thresholdService.replacementThresholdControllerFind(props).pipe(
          mapResponse({
            next: (r) =>
              thresholdActions.loadThresholdDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
              }),
            error: (error: ZetraError) =>
              thresholdActions.loadThresholdDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);

export const deleteThresholdEffect = createEffect(
  (actions$ = inject(Actions), thresholdService = inject(ReplacementThresholdService)) => {
    return actions$.pipe(
      ofType(thresholdActions.deleteThreshold),
      exhaustMap((props) =>
        thresholdService.replacementThresholdControllerDelete(props).pipe(
          mapResponse({
            next: () =>
              thresholdActions.deleteThresholdDone({
                state: { value: LoadingState.SUCCESS },
              }),
            error: (error: ZetraError) =>
              thresholdActions.deleteThresholdDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'error', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);

export const setTrakingEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(ReplacementThresholdService)) => {
    return actions$.pipe(
      ofType(thresholdActions.setTraking),
      exhaustMap((props) =>
        compService.replacementThresholdControllerSetTraking({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              thresholdActions.setTrakingDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
              }),
            error: (_error: { message: string }) =>
              thresholdActions.setTrakingDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: "Impossibile recuperare l'elenco dei modelli." },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
